"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const asyncQueuer = require("@tanstack/pacer/async-queuer");
const reactStore = require("@tanstack/react-store");
const PacerProvider = require("../provider/PacerProvider.cjs");
function useAsyncQueuer(fn, options = {}, selector = () => ({})) {
  const mergedOptions = {
    ...PacerProvider.useDefaultPacerOptions().asyncQueuer,
    ...options
  };
  const [asyncQueuer$1] = react.useState(
    () => new asyncQueuer.AsyncQueuer(fn, mergedOptions)
  );
  asyncQueuer$1.fn = fn;
  asyncQueuer$1.setOptions(mergedOptions);
  const state = reactStore.useStore(asyncQueuer$1.store, selector);
  return react.useMemo(
    () => ({
      ...asyncQueuer$1,
      state
    }),
    // omit `store` in favor of `state`
    [asyncQueuer$1, state]
  );
}
exports.useAsyncQueuer = useAsyncQueuer;
//# sourceMappingURL=useAsyncQueuer.cjs.map
